if (typeof PAR === "undefined") var PAR = {};
if (typeof PAR.wizard === "undefined") PAR.wizard = {};
if (typeof PAR.wizard.selectors === "undefined") PAR.wizard.selectors = {};
PAR.wizard.selectors.acContainer = [];
PAR.wizard.selectors.input = [];

(function ($) {
    function suggestions(wizard_id, input) {
        var acContainer = $(PAR.wizard.selectors.acContainer[wizard_id]),
            input = $(PAR.wizard.selectors.input[wizard_id]),
            searchstring = typeof $(input) !== "undefined" ? $(input).val() : "",
            per_page = 15,
            len = 0,
            name = "",
            json = $(`${wizard_id}`).data("json"),
            data = json ? $.extend(true, {}, json) : false;

        if (!json) return false;
        if (!data) return false;

        // console.log(json);
        // acContainer.html("data: " + data['data']);
        acContainer.html("");

        if (typeof searchstring !== "string" || searchstring.length < 3) {
            $(`${wizard_id} #navigation-container-next`).hide();
            return false;
        } else {
            $(`${wizard_id} #navigation-container-next`).show();
        }

        data.wizard = data.wizard.filter(function (e) {
            var s1 = typeof e.p["post_title"] !== "undefined" ? e.p["post_title"] : "",
                s2 = typeof e.acf["firstname"] !== "undefined" ? e.acf["firstname"] : "",
                s3 = typeof e.acf["lastname"] !== "undefined" ? e.acf["lastname"] : "",
                // hide-in-finder wird schon in der api abgefangen
                // hide = typeof e.acf["hide-in-finder"] !== "undefined" && e.acf["hide-in-finder"],
                // also change searchable_string in private/packages/themes/par/inc/par-person.php
                searchable_string = `${s1} ${s2} ${s3}`;
            // return !hide && typeof searchstring === "string" && searchable_string.toLowerCase().indexOf(searchstring.toLowerCase()) != -1;
            return typeof searchstring === "string" && searchable_string.toLowerCase().indexOf(searchstring.toLowerCase()) != -1;
        });
        len = data.wizard.length;

        acContainer.addClass("ac-loading");

        if (len < 1) {
            $(`${wizard_id} #navigation-container-next`).hide();
            acContainer.append(`<div>Es wurden keine Vorschl&auml;ge f&uuml;r Ihre Eingabe gefunden.</div>`);
            acContainer.removeClass("ac-loading");
            return false;
        }

        // if (len == 1) acContainer.append(`<div>Vorschlag für '${searchstring}':&nbsp;</div>`);
        // if (len > 1) acContainer.append(`<div>Vorschläge für '${searchstring}':&nbsp;</div>`);
        acContainer.append(`<div>W&auml;hlen Sie einen Vorschlag:&nbsp;</div>`);

        data.wizard.slice(0, per_page).forEach((vorschlag) => {
            name = vorschlag.p.post_title;
            acContainer.append(`<a href='#' class='badge badge-primary mr-1 mb-1'>${name}</a>`);
        });
        if (per_page < len) acContainer.append(`<div>Es werden ${per_page} von ${len} Treffer angezeigt.</div>`);
        acContainer.removeClass("ac-loading");
    }

    function addperson(e, wizard_id) {
        var acContainer = $(PAR.wizard.selectors.acContainer[wizard_id]),
            input = $(PAR.wizard.selectors.input[wizard_id]),
            val = $(e.target).text();

        e.preventDefault();

        acContainer.html("");

        if ($(input)) {
            input.val(val);
            input.trigger("input");
        }

        return false;
    }

    function init(wizard_id) {
        var acContainer_s = `${wizard_id} .uva-wizard-textfield .ac-container`,
            input_s = `${wizard_id} #personsuche-name.wizard-textfield-active`;

        PAR.wizard.selectors.acContainer[wizard_id] = acContainer_s;
        PAR.wizard.selectors.input[wizard_id] = input_s;

        if ($(acContainer_s) && $(acContainer_s).length < 1) {
            $(`${wizard_id} .uva-wizard-textfield`).append('<div class="ac-container"></div>');
        }

        $(`${wizard_id} #navigation-container-next`).hide();
        $(`${wizard_id}`).on("click", `.ac-container a`, function (e) {
            addperson(e, wizard_id);
            $(`${wizard_id} #wizard-next`).trigger("click");
        });

        $(`${wizard_id}`).on("keyup", 'input[name="personsuche-name"]', function () {
            suggestions(wizard_id);
        });
        $(`${wizard_id}`).on("click", `#wizard-next`, function () {
            $(PAR.wizard.selectors.acContainer[wizard_id]).html("");
        });

        jQuery
            .ajax({
                url: `/wp-json/par/v1/wizard-api/person/s=/n=`,
                type: "GET",
                dataType: "json",
                data: {
                    clinic: typeof $(`body`).data("session") !== "undefined" ? $(`body`).data("session") : "noclinic",
                    query: $(`${wizard_id} input[name="personsuche-name"]`).data("query"),
                },
            })
            .success(function (data, textStatus, request) {})
            .done(function (data, textStatus, request) {
                $(`${wizard_id}`).data("json", data);
                suggestions(wizard_id);
            });
    }

    function init_reset() {
        if (typeof UVA !== "undefined" && typeof UVA.wpwizard !== "undefined" && typeof UVA.wpwizard.activeWizards !== "undefined") {
            //-- Reset on button click --
            $('button[data-target="#wizard-clinic-modal"]').on("click", function () {
                UVA.wpwizard.activeWizards[0].reset();
            });
            $('button[data-target="#wizard-info-modal"]').on("click", function () {
                UVA.wpwizard.activeWizards[1].reset();
            });
            $('button[data-target="#wizard-person-modal"]').on("click", function () {
                UVA.wpwizard.activeWizards[2].reset();
            });
        }else{
            console.log("UVA object not found");
        }
    }

    $(function () {
        init_reset();
        init(`#wizard-person-modal`);
        init(`.wizard-arztsuche`);
        // init(`.wizard-wizard-relation-zuweiser`);
        init(`.wizard-erw-arztsuche`);
        console.log("init wizards finished");
    });
})(jQuery);
